import type { CardListing } from 'cards/components/CardListing/types';
import type { CardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

export const FILTER_TYPE_ALL = 'all';

export type FilterCardType = CardType | typeof FILTER_TYPE_ALL | 'DIGITAL_SAVE_THE_DATE';

export type FavoriteCardSuiteUUIDs = Array<string>;

export type FavoriteCardSuite = CardListing;

export type FavoriteCardSuites = Array<FavoriteCardSuite>;

export type FavoriteCardSuitesByCardType = {
  [key in FilterCardType]?: FavoriteCardSuites;
};
